<ng-container *ngTemplateOutlet="blockBtn ? blockBtnBody : btnBody">
</ng-container>

<ng-template #blockBtnBody>
	<div class="d-grid">
		<ng-container *ngTemplateOutlet="btnBody"></ng-container>
	</div>
</ng-template>

<ng-template #btnBody>
	<button
		(click)="clickBtn.emit()"
		class="btn"
		[ngClass]="{
			'btn-primary': severity === 'primary' && !isOutline,
			'btn-warning': severity === 'warning' && !isOutline,
			'btn-success': severity === 'success' && !isOutline,
			'btn-danger': severity === 'danger' && !isOutline,
			'btn-link': severity === 'link' && !isOutline,
			'btn-secondary': severity === 'secondary' && !isOutline,

			'btn-outline-primary': severity === 'primary' && isOutline,
			'btn-outline-warning': severity === 'warning' && isOutline,
			'btn-outline-success': severity === 'success' && isOutline,
			'btn-outline-danger': severity === 'danger' && isOutline,
			'btn-outline-link': severity === 'link' && isOutline,
			'btn-outline-secondary': severity === 'secondary' && isOutline
		}"
		[disabled]="disabled || isLoading"
		[type]="type"
		[attr.form]="form"
	>
		<div
			[class.justify-content-center]="blockBtn"
			class="d-flex align-items-center"
		>
			<i
				*ngIf="hasIcon() && !isLoading"
				[ngClass]="{
					'order-first icon-pos-left': iconPosition === 'left',
					'order-last icon-pos-right': iconPosition === 'right'
				}"
				[class]="icon"
			></i>
			<div
				*ngIf="isLoading"
				class="spinner-border"
				role="status"
				style="margin-right: 0.3rem; height: 1rem; width: 1rem"
			>
				<span class="visually-hidden">Loading...</span>
			</div>
			<ng-content></ng-content>
			<span *ngIf="hasBadge()" class="ms-2 badge bg-secondary">4</span>
		</div>
	</button>
</ng-template>
